import { render, staticRenderFns } from "./label-detail.vue?vue&type=template&id=6df09c64&scoped=true"
import script from "./label-detail.vue?vue&type=script&lang=js"
export * from "./label-detail.vue?vue&type=script&lang=js"
import style0 from "./label-detail.vue?vue&type=style&index=0&id=6df09c64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_4rliqqz3ui7xo7iaw2ukiguuga/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df09c64",
  null
  
)

export default component.exports